let DEFAULT_BASE_URL =
  "https://services-dev.ultainc.com/data-science/api/v1/vba-api/qa"; // window.location.origin;
let API_KEY = "7nvDL4dQB6q385KrenKEWzJkGRMTaBeZ";
const QA_ORIGIN_REGEX = /^https?:\/\/qa(10|[1-9])\.ulta\.com/;
const DEV_ORIGIN_REGEX = /^https?:\/\/da1\.ulta\.com/;
const origin = window.location.origin;

if (origin === "https://www.ulta.com") {
  DEFAULT_BASE_URL =
    "https://services.ultainc.com/data-science/api/v1/vba-api/qa";
  API_KEY = "BgzkEV5GyFamBdKA1K4UYq1b7aLurIyA";
} else if (origin === "https://stress.ulta.com") {
  DEFAULT_BASE_URL =
    "https://services-stress.ultainc.com/data-science/api/v1/vba-api/qa";
} else if (QA_ORIGIN_REGEX.test(origin)) {
  DEFAULT_BASE_URL =
    "https://services-qa.ultainc.com/data-science/api/v1/vba-api/qa";
}

export async function Request(options) {
  const { method = "GET", data, baseUrl = DEFAULT_BASE_URL } = options;

  try {
    let body;
    if (!!data) body = JSON.stringify(data);

    const defaultHeaders = {
      "Content-Type": "application/json",
      "x-api-key": API_KEY,
    };

    const endpoint = baseUrl;
    const response = await fetch(endpoint, {
      method,
      body,
      headers: defaultHeaders,
    });

    if (!response.ok) {
      const error = new Error(response.statusText);
      Object.assign(error, { response });
      throw error;
    }

    return response.status === 204 ? response : await response.json();
  } catch (err) {
    throw err;
  }
}

export function ActivityCall(userId, actionId) {
  const origin = window.location.origin;
  const devOrQa =
    QA_ORIGIN_REGEX.test(origin) || DEV_ORIGIN_REGEX.test(origin);
  const baseURL = devOrQa
    ? "https://services-dev.ultainc.com"
    : "https://services.ultainc.com";
  const apiKey = devOrQa
    ? "vTAdVJMYpGfUAZmIT73p4NKAxw6Gyopf"
    : "bBZmfh8lLMo4EAvYkeS8IKmtEvaJ6oKv";
  const payload = {
    uid: userId,
    actionId: actionId,
    application: process.env.REACT_APP_NFT_APPLICATION_ID,
  };
  fetch(`${baseURL}/innovation/api/nft/v1/activity`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-api-key": apiKey,
      Referer: "https://postman.ulta.com",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      if (response.ok) {
        console.log("NFT event sent successfully", response);
      } else {
        console.log("NFT event sending failed", response);
      }
    })
    .catch((err) => {
      console.log("Something went wrong while sending NFT events", err);
    });
}
